import auth from './auth';

const Api = {
  auth,
};

export default Api;
